import React, { useState } from 'react';
import axios from 'axios';
import { Link, useHistory } from "react-router-dom";

export default function Login() {
    const [name, setName] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const api = "https://apibbytowing.vercel.app";
    const navigate = useHistory();

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post(api + '/api/login-admin', { name, password });
            localStorage.setItem('accessToken', response.data.accToken);
            navigate.push('/');
            window.location.reload();
        } catch (error) {
            setError(error.response.data.error);
        }
    };

    return (
        <main className='p-8 md:p-24 flex w-full h-full items-center justify-center'>
            <section className="w-96 rounded-2xl bg-[#fcfc00c0] shadow-md">
                <form onSubmit={handleLogin}>
                    <div className="flex flex-col gap-2 p-8">
                        <h1 className="text-center text-3xl text-black mb-4">Login</h1>
                        {error && <p className='text-center text-red-600 mb-4'>{error}</p>}
                        <label htmlFor="username" className="sr-only">Username</label>
                        <input
                            id="username"
                            type="text"
                            className="bg-white w-full rounded-lg border border-gray-300 px-4 py-3 focus:outline-none focus:ring-2 focus:ring-gray-700 focus:ring-offset-2 focus:ring-offset-gray-800"
                            placeholder="Username"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                        <label htmlFor="password" className="sr-only">Password</label>
                        <input
                            id="password"
                            type="password"
                            className="bg-white w-full rounded-lg border border-gray-300 px-4 py-3 focus:outline-none focus:ring-2 focus:ring-gray-700 focus:ring-offset-2 focus:ring-offset-gray-800"
                            placeholder="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                        <button
                            type="submit"
                            className="inline-block cursor-pointer rounded-md bg-gray-700 px-4 py-3.5 mt-4 text-center text-sm font-semibold uppercase text-white transition duration-200 ease-in-out hover:bg-gray-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-700 focus-visible:ring-offset-2 active:scale-95"
                        >
                            Login
                        </button>
                    </div>
                </form>
            </section>
        </main>
    );
}
